import { selectStandardProps } from "@/utils/componentUtils";
import { Form, Select } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { FormItemProps } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";
import { useGetVehicleBrands } from "../../../../common/api/queries";
import { VEHICLE_OTHER_MAPPING_NAME } from "../../enums";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<string>;
  onChangeIsOther?: (isOther: boolean) => void;
}

export const VehicleBrandSelect = ({ formItemProps, selectProps, onChangeIsOther }: Props) => {
  const { data, isFetching } = useGetVehicleBrands();

  return (
    <Form.Item {...formItemProps}>
      <Select
        {...selectStandardProps}
        {...selectProps}
        options={data?.map((brand) => ({ value: brand.id, label: brand.name }))}
        loading={isFetching}
        onChange={(value, option?: DefaultOptionType) => {
          onChangeIsOther?.(option?.label === VEHICLE_OTHER_MAPPING_NAME);
          selectProps?.onChange?.(value, option);
        }}
        labelRender={(item) => item.label ?? ""}
      />
    </Form.Item>
  );
};
